export var PromoMessageIcons;
(function (PromoMessageIcons) {
    PromoMessageIcons["TimeIsMoney"] = "TimeIsMoney";
})(PromoMessageIcons || (PromoMessageIcons = {}));
